import styled from 'styled-components';

import { fontWeights } from 'styles/variables';
import { levels } from 'styles/z-index';
import {
  gray50,
  gray85,
  gray90,
  solidBlack0,
  spotifyGreen157,
} from '@spotify-internal/encore-web';

export const Checkbox = styled.label`
  align-items: center;
  box-sizing: content-box;
  color: ${gray50};
  display: flex;
  font-size: 1.8rem;
  font-weight: ${fontWeights.normal};
  margin-bottom: 1.6rem;
  position: relative;

  span {
    flex: 1;
    padding-left: 1.6rem;
  }

  input {
    opacity: 0;
    position: absolute;
    z-index: ${levels.behind};
  }

  input[type='checkbox'] ~ div {
    border: 0.1rem solid ${gray50};
    border-radius: 50%;
    flex: none;
    height: 1.6rem;
    left: 0;
    position: relative;
    top: 0;
    width: 1.6rem;

    &::after {
      border: solid ${solidBlack0};
      border-width: 0 0.2rem 0.2rem 0;
      content: '';
      display: none;
      height: 1rem;
      left: 0.6rem;
      position: absolute;
      top: 0.1rem;
      transform: rotate(45deg);
      width: 0.25rem;
    }
  }

  input:disabled ~ div::after {
    border-color: ${gray90};
  }

  input:checked ~ div::after {
    display: block;
  }

  input:focus ~ div {
    box-shadow: 0 0 0.5rem 0.2rem rgba(0, 106, 255, 0.57);
  }

  input:checked ~ div {
    background: ${spotifyGreen157};
  }

  input[type='checkbox']:disabled ~ div {
    background: ${gray85};
    cursor: not-allowed;
    opacity: 0.6;
  }

  input:checked:focus ~ div,
  &:hover input:not([disabled]):checked ~ div {
    background: ${spotifyGreen157};
  }

  div::before {
    background: ${spotifyGreen157};
    border-radius: 2rem;
    content: '';
    display: block;
    height: 3rem;
    left: 0;
    margin-left: -0.85rem;
    margin-top: -0.85rem;
    opacity: 0.6;
    position: absolute;
    top: 0;
    transform: scale(0);
    width: 3rem;
  }
`;

export const Container = styled.fieldset`
  margin: 0;
  padding: 0;
`;
